var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:_vm.className},_vm._l((_vm.messages),function(message){return _c('li',{key:message},[_c('app-text',{attrs:{"size":_vm.textSize,"height":_vm.lineHeight}},[_vm._v(_vm._s(message))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }